/**
 * Visibility Rules Index
 * 
 * Aggregates all visibility rules from different UI concerns.
 */

import { carouselRules } from './carousel-rules';
import { heroRules } from './hero-rules';
import { stickyHeaderRules } from './sticky-header-rules';
import { contentRules } from './content-rules';
import { footerRules } from './footer-rules';
import { sidebarRules } from './sidebar-rules';
import { ExperimentElement, type Rule } from '../../types';

/**
 * Merged visibility rules from all UI concerns
 * 
 * DEFAULT: Elements show on all viewports unless rules specify otherwise.
 * 
 * Rules can be either:
 * - Declarative (VisibilityRule object with hideWhen/showWhen)
 * - Function that takes VisibilityContext and returns boolean
 */
export const VISIBILITY_RULES: Partial<Record<ExperimentElement, Rule>> = {
  ...carouselRules,
  ...heroRules,
  ...stickyHeaderRules,
  ...contentRules,
  ...footerRules,
  ...sidebarRules,
  
  // Add more rule sets here as needed:
};
